/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useTranslation } from "react-i18next";

// Component imports
import { Card, Col, Row } from "antd";
import { Container } from "@/components/UI/Container";
import { EditProfileForm } from "@/components/Forms/EditProfileForm";
import { BackButton } from "@/components/UI/BackButton";

// Misc imports
import { NAV_PROFILE } from "@/constants";

/**
 * Component to be used to edit my profile
 * @returns JSX.Element
 */
export const EditProfileScreen = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row align={"middle"} justify={"center"} className="w-100">
        <Col xs={24} md={16}>
          <BackButton to={NAV_PROFILE} />
          <Card title={t("menu.profile")}>
            {/* Edit profile form */}
            <EditProfileForm />
            {/* ./ Edit profile form */}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
